import { useFetch } from 'hooks';
import { MfaEnrollment } from 'types/interfaces/user/MFAEnrollment';

interface MfaApiFunctions {
  getMfaEnrollmentAsync: (signal?: AbortSignal) => Promise<MfaEnrollment>;
  skipMfaAsync: (signal?: AbortSignal) => Promise<void>;
  acceptMfaAsync: (signal?: AbortSignal) => Promise<void>;
}

export const useMfaFunctions = (): MfaApiFunctions => {
  const { get, post } = useFetch();

  async function remoteGetMfaInfoAsync(
    signal?: AbortSignal
  ): Promise<MfaEnrollment> {
    const url = `/usermanagement/mfa-enrollments`;
    const res = await get(url, signal);

    if (res.status !== 200) {
      throw new Error('Something went wrong');
    }

    const data = await res?.json();
    const dataTyped = data as { enrollments: MfaEnrollment[] };
    const enrollment =
      !dataTyped?.enrollments || dataTyped.enrollments.length === 0
        ? null
        : data.enrollments[0];

    return enrollment;
  }

  async function remotelySkipMFAAsync(signal?: AbortSignal): Promise<void> {
    const url = `/usermanagement/skip-mfa`;
    await post(url, {}, signal);
  }

  async function remotelyAcceptMFAAsync(signal?: AbortSignal): Promise<void> {
    const url = `/usermanagement/accept-mfa`;
    await post(url, {}, signal);
  }

  return {
    getMfaEnrollmentAsync: remoteGetMfaInfoAsync,
    skipMfaAsync: remotelySkipMFAAsync,
    acceptMfaAsync: remotelyAcceptMFAAsync,
  };
};

export default useMfaFunctions;
